export default "__VITE_ASSET__D$2caTk0__"